import React from 'react'

import { Button } from '@mui/material'
import { Equalizer as EqualizerIcon } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { useJasperLogin } from '../../../spark_libs_deprecated/feature-jasper'

interface Props {
    href: string
}

export const ReportActionButton: React.FC<Props> = ({ href }: Props) => {
    const loginToJasper = useJasperLogin()

    return (
        <Button
            color="primary"
            variant="contained"
            startIcon={<EqualizerIcon />}
            component={Link}
            to={href}
            size="small"
            disabled={!href}
        >
            Report
        </Button>
    )
}
